import { Component, OnInit, ViewChild } from '@angular/core';
import { Router } from '@angular/router';
import { DatePipe } from '@angular/common';
import { TypeResponse } from '@app/shared/enum/TypeResponse';
import { MessageService } from '@app/shared/services/message.service';
import { ModalDismissReasons, NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { StatusCrmCss, StatusCrmLabel } from '@app/shared/enum/StatusCrm';
import { InitStudentService } from '@app/student/services';
import { User } from '@app/auth/model';
import { first } from 'rxjs/operators';
import { Student } from '@app/admin/model';
import { UserCreditDebitService } from '@app/financial/services';
import { UserCreditDebitSummary } from '@app/financial/model/userCreditDebitSummary';
import { IndicationService } from '@app/marketing/services';

@Component({
  templateUrl: 'indication-list.component.html',
  providers: [DatePipe],
})
export class IndicationListComponent implements OnInit {
  @ViewChild('mdContactPreRegister') mdContactPreRegister: any;
  public contacts: any = [];
  public showTable: boolean;
  public dateNow = new Date();
  dataResult: boolean = false;
  public returnMessage = '';
  closeResult: string;
  contactId: number;
  public statusCrm: string = null;
  public previewMode = false;

  public creditDebitSummary = new UserCreditDebitSummary();
  public indicationId: number = 0;

  private student: Student;
  public user: User = new User();

  public columns: Array<any> = [
    { title: 'Código', name: 'id', sort: 'asc', className: 'text-center' },
    { title: 'Nome', name: 'name', sort: 'asc' },
    { title: 'E-mail', name: 'email', sort: 'asc', className: 'text-center' },
    { title: 'Telefone', name: 'phone', sort: 'asc', className: 'text-center' },
    {
      title: 'Status Atual',
      name: 'designStatus',
      sort: 'asc',
      className: 'text-center fw-700',
      isHtmlData: true,
    },
    {
      title: 'Status do<br>Crédito',
      name: 'creditStatus',
      sort: 'asc',
      className: 'text-center text-primary',
      isHtmlData: true,
    },
    {
      title: 'Última<br>Atualização',
      name: 'updatedOn',
      sort: 'asc',
      className: 'text-center font-weight-bold text-info datetime',
    },
  ];

  constructor(
    private userCreditDebitService: UserCreditDebitService,
    private indicationService: IndicationService,
    private initStudent: InitStudentService,
    private loading: MessageService,
    private modalService: NgbModal,
    private router: Router
  ) {
    this.initStudent.setConfigPage(false, false);
  }

  ngOnInit(): void {
    this.loading.showLoading();
    this.dataResult = false;
    this.statusCrm = null;
    this.getUserData();
  }

  getUserData() {
    if (this.initStudent.user != null && this.initStudent.user.id > 0) {
      this.initStudent
        .getStudentUser()
        .pipe(first())
        .subscribe(
          (response: any) => {
            this.student = response;
            this.user = this.initStudent.user;
            this.initialyze();
          },
          (error: any) => {
            this.initialyze();
          }
        );
    } else {
      this.initialyze();
    }
  }

  initialyze() {
    this.user = this.initStudent.user;
    this.loadIndications(this.user.userId);
    this.getUserCreditDebitSummary(this.user.userId);
    this.loading.hideLoading();
  }

  loadIndications(userId: string) {
    this.loading.showLoading();
    this.indicationService.getByIndication(userId).subscribe(
      (response: any) => {
        if (response.typeResponse == TypeResponse.Success) {
          this.contacts = response.data;
          this.reviewDataList(this.contacts);
          this.showTable = true;
          this.returnMessage = '';
        } else {
          this.returnMessage = response.message;
          this.showTable = false;
        }
        this.loading.hideLoading();
      },
      (error: any) => {
        this.loading.hideLoading();
        this.showTable = false;
        this.returnMessage = 'Erro ao carregar os dados das indicações.';
      }
    );
  }

  getUserCreditDebitSummary(userId: string) {
    this.loading.showLoading();
    this.userCreditDebitService.summaryByUserGuid(userId).subscribe(
      (response: any) => {
        if (response.typeResponse == TypeResponse.Success) {
          this.creditDebitSummary = response.data;
          this.returnMessage = '';
        } else {
          this.returnMessage = response.message;
        }
        this.loading.hideLoading();
      },
      (error: any) => {
        this.loading.hideLoading();
        this.returnMessage = 'Erro ao carregar os dados dos créditos/débitos do usuário.';
      }
    );
  }

  resetStatusPage() {
    this.loading.showLoading();
    window.location.replace(window.location.href.split(';')[0]);
    window.location.reload();
  }

  reviewDataList(lista: any[]) {
    lista.forEach(function (e) {
      if (e.statusCrm >= 0) {
        let statusCrmStr = StatusCrmLabel.get(e.statusCrm);
        let statusCrmCss = StatusCrmCss.get(e.statusCrm);
        e.designStatus =
          "<span class='badge w-100 " +
          statusCrmCss +
          " badge-pill py-1 px-3'>" +
          statusCrmStr +
          '</span>';
      }

      if (e.userCreditDebit) {
        e.creditStatus = `<span class="badge badge-pill py-1 px-3 text-white bg-success">Crédito Disponível</span>`;
        if (e.userCreditDebit.creditUsed) {
          e.creditStatus = `<span class="badge badge-pill py-1 px-3 text-white bg-primary">Crédito Utilizado</span>`;
        }
      } else {
        e.creditStatus = `<span class="badge badge-pill py-1 px-3 text-white bg-secondary">Crédito Bloqueado</span>`;
      }
    });
    this.contacts = lista;
  }

  private getDismissReason(reason: any): string {
    if (reason === 3) {
      return 'by opening next modal';
    } else {
      if (reason === ModalDismissReasons.ESC) {
        return 'by pressing ESC';
      } else if (reason === ModalDismissReasons.BACKDROP_CLICK) {
        return 'by clicking on a backdrop';
      } else if (reason === 2) {
        return 'by clicking on a close button';
      } else {
        return `with: ${reason}`;
      }
    }
  }

  newIndication(content: any) {
    this.previewMode = false;
    this.modalService.dismissAll();
    this.open(content);
  }

  preview(row: any, content: any): void {
    this.loading.showLoading();
    this.indicationId = row.id;
    this.previewMode = true;
    this.open(content);
  }

  open(content: any) {
    this.modalService.open(content, {
      backdrop: 'static',
      size: 'lg',
      windowClass: 'animated fade',
    })
    .result.then(
      (result) => {
        this.closeResult = `Closed with: ${result}`;
      },
      (reason) => {
        this.closeResult = `Dismissed ${this.getDismissReason(reason)}`;
      }
    );
  }

  dismissModal() {
    this.modalService.dismissAll();
  }
}
